(function() {
	/**
	 * Renders news detail page: [News Item]
	 * @param {Object} props - The Routing and page context and properties
	 * @returns {object} 	Promise with data (nav for menu, etc.)
	 */
	WebBaseAprovLV.renderArticlePage = function(props) {
		var params = {
			page: props.context.params.page || '',
			detail: props.context.params.detail || ''
		};
		var model = {
			element: null,
			template: 'templates/article.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {
				main: (props.context.Model || {}).Main || {}, /* Comes from renderMainContent() */
				pageRaw: null,
				navRaw: null,
				article: null,
				articleRaw: null,
				related: [],
				nav: null,
				pageContent: null
			}
		};
		return $.when(
			// WebBaseAprovLV.Utils.getKKData('?system.type=page&system.codename[in]=news'),
			WebBaseAprovLV.Utils.getKKData('?system.type=page&elements.url[in]=' + params.page + '&depth=1'),
			WebBaseAprovLV.Utils.getKKData('?system.type=news&elements.url[in]=' + params.detail),
			ejs.preloadTemplate(model.template),
			ejs.preloadTemplate('templates/breadcrumb.ejs.html?v=' + WebBaseAprovLV.version.template),
			ejs.preloadTemplate('templates/bottomnav.ejs.html?v=' + WebBaseAprovLV.version.template)
		).then(function(pageXhr, articleXhr, tmplPage, tmplBreadcrumb, tmplBottomnav) {
			var pageRaw = Array.isArray(pageXhr) && pageXhr.length ? pageXhr[0] : (pageXhr || {});
			var articleRaw = Array.isArray(articleXhr) && articleXhr.length ? articleXhr[0] : (articleXhr || {});
			var categoryQueryNames = [];
			var categoryQueryString = '';
			model.data.navRaw = {};
			model.data.pageRaw = pageRaw;
			model.data.articleRaw = articleRaw;
			model.element = $('#content');
			model.data = $.extend(model.data, {
				pageContent: WebBaseAprovLV.Utils.getKKViewModel(model.data.pageRaw)[0] || {},
				nav: WebBaseAprovLV.Utils.getKKViewModel(model.data.navRaw)[0] || {},
				article: WebBaseAprovLV.Utils.getKKViewModel(model.data.articleRaw)[0] || {}
			});
			categoryQueryNames = (model.data.article.news_categories || []).map(function(c) {
				return c.codename || '';
			});
			if (categoryQueryNames.length) {
				categoryQueryString = '&elements.news_categories';
				if (categoryQueryNames.length === 1) {
					categoryQueryString += '[contains]=' + encodeURIComponent(categoryQueryNames[0]);
				} else if (categoryQueryNames.length > 1) {
					categoryQueryString += '[any]=' + encodeURIComponent(categoryQueryNames.join(','));
				}
			}
			if (model.data.article.system_codename) {
				return WebBaseAprovLV.Utils.getKKData('?system.type=news&includeTotalCount=false&system.codename[neq]=' + model.data.article.system_codename + categoryQueryString + '&order=elements.date[desc]&depth=1&limit=3');
			}
			return {};
		}).then(function(relatedXhr) {
			model.data.related = (relatedXhr.items || []).length ? WebBaseAprovLV.Utils.getKKViewModel(relatedXhr) || [] : [];
			return WebBaseAprovLV.Utils.transitionTo(model);
		}).then(function(ejsmodel) {
			ejsmodel.data.UILangSwitch = WebBaseAprovLV.Utils.tuneUILangSwitchers({
				page: {
					id: ((ejsmodel.data.pageContent || {}).system_id || ''),
					segment: 'news'
					/* segment: {
						'de': 'news',
						'it': 'news',
						'lld': 'news'
					} */
				},
				detail: {
					id: ((ejsmodel.data.article || {}).system_id || '')
				}
			}, $('a.langchange'));
			return ejsmodel;
		}).promise();
	};
})();
